import React, { Component } from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CrewContainer from '../../layouts-components__common-cases/crew-container';
import CommonTitle from '../../../common-components/common-title';

const webpractikTeam = {
    crewTitle: 'Вебпрактик',
    crewSubtitle: null,
    crewList: [
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Игорь Никитин',
            crewItemSubtitle: 'руководитель проекта',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Александр Забанов',
            crewItemSubtitle: 'Back-end teamlead',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Николай Фетинг',
            crewItemSubtitle: 'Back-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Пётр Шкумат',
            crewItemSubtitle: 'Back-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Пётр Кленкин',
            crewItemSubtitle: 'старший Back-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Константин Кулишов',
            crewItemSubtitle: 'старший DevOps инженер',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Николай Цай',
            crewItemSubtitle: 'старший дизайнер',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Даниил Никонюк',
            crewItemSubtitle: 'Front-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Олеся Прокопенко',
            crewItemSubtitle: 'Front-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Мурад Саркаров',
            crewItemSubtitle: 'Front-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Анастасия Бабич',
            crewItemSubtitle: 'контент-менеджер',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Роман Возный',
            crewItemSubtitle: 'контент-менеджер',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Анна Сластен',
            crewItemSubtitle: 'дизайнер',
        },
    ],
};

class Team extends Component {
    render() {
        return (
            <FullWrapper className="team" isMargin={false}>
                <CommonTitle>Команда</CommonTitle>
                <CrewContainer container={webpractikTeam} />
            </FullWrapper>
        );
    }
}

export default Team;
